import { EXCLUDE_COLUMNS_IF_EXECUTED, EXCLUDED_COLUMNS, ListTab } from '@modules/tender-platform/constants';
import { TableConfig } from '@common/types';
import { compareAsString } from '@common/utils';

export const getTenderSearchTableColumns = ({ columns, currentTab }: { columns: TableConfig['columns']; currentTab: ListTab }) => {
  return EXCLUDE_COLUMNS_IF_EXECUTED.includes(currentTab)
    ? columns?.filter(({ dataIndex }) => !EXCLUDED_COLUMNS.find((columnDataIndex) => compareAsString(columnDataIndex, dataIndex)))
    : columns;
};
